import { getDocument, useDocument } from "hooks/firestore/core/useDocument"
import { WithRef } from "hooks/firestore/FirestoreDocument"
import { getAccountRef } from "hooks/firestore/getRefs"
import { useShopId } from "hooks/localstate/context/useShopId"
import { Account } from "types/firestore/account"

// ts-prune-ignore-next
export function useAccount(): WithRef<Account> | undefined
export function useAccount(shopId: string): WithRef<Account> | undefined
export function useAccount(shopId?: string) {
  // TypeScript function overloads should prevent conditional calling of the hook
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const realShopId = shopId || useShopId()
  const { document } = useDocument(getAccountRef(realShopId))
  return document
}

// ts-prune-ignore-next
export async function getAccount(shopId: string) {
  return await getDocument(getAccountRef(shopId))
}
